// ==============================
// Imports
// ==============================

// MUI Components
import AssessmentIcon from '@mui/icons-material/Assessment';
import HomeIcon from '@mui/icons-material/Home';
import ClientIcon from '@mui/icons-material/Person';
import RegistrationIcon from '@mui/icons-material/AppRegistration';
import ClassIcon from '@mui/icons-material/School';
import ReportIcon from '@mui/icons-material/QueryStats';
import SurveyResponsesIcon from '@mui/icons-material/FactCheck';
import SettingsIcon from '@mui/icons-material/Settings';
import CourseSettingIcon from '@mui/icons-material/Sports';
import ServiceSettingIcon from '@mui/icons-material/Inventory';
import FormSettingIcon from '@mui/icons-material/DynamicForm';
import TrialBookingIcon from '@mui/icons-material/Pool';
import CoachIcon from '@mui/icons-material/SupervisedUserCircle';
import StorageIcon from '@mui/icons-material/Storage';
import HistoryIcon from '@mui/icons-material/ManageHistory';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import ParentLookupIcon from '@mui/icons-material/QrCode2';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import UserGuideIcon from '@mui/icons-material/MenuBook';

// Local Components
import AssessmentLayout from '../pages/Assessment';
import ClassLayout from '../pages/Class';
import HomeLayout from '../pages/Home';
import ClientLayout from '../pages/Client';
import CoachLayout from '../pages/Coach';
import TrialBookingLayout from '../pages/TrialBooking';
import RegistrationLayout from '../pages/Registration';
import ReportLayout from '../pages/Report/Report';
import ServiceSetting from '../pages/Setting/ServiceSetting';
import CourseSetting from '../pages/Setting/CourseSetting';
import ImportDataSetting from '../pages/Setting/ImportDataSetting';
import AuditLogSetting from '../pages/Setting/AuditLogSetting';
import AccountManagement from '../pages/Setting/AccountManagement';
import ParentLookupSetting from '../pages/Setting/ParentLookupSetting';

// ==============================
// Render
// ==============================
export default function () {
  const data = [
    {
      id: 0,
      label: 'Home',
      labelKey: 'nav.home',
      img: <HomeIcon />,
      component: <HomeLayout />,
      path: '/home',
    },
    {
      id: 1,
      label: 'User',
      labelKey: 'nav.user',
      img: <ClientIcon />,
      component: <ClientLayout />,
      path: '/client',
    },
    {
      id: 2,
      label: 'Coach',
      labelKey: 'nav.coach',
      img: <CoachIcon />,
      component: <CoachLayout />,
      path: '/coach',
    },
    {
      id: 3,
      label: 'Trial Booking',
      labelKey: 'nav.trialBooking',
      img: <TrialBookingIcon />,
      component: <TrialBookingLayout />,
      path: '/trial-booking',
    },
    {
      id: 4,
      label: 'Registration',
      labelKey: 'nav.registration',
      img: <RegistrationIcon />,
      component: <RegistrationLayout />,
      path: '/registration',
    },
    {
      id: 5,
      label: 'Assessment',
      labelKey: 'nav.assessment',
      img: <AssessmentIcon />,
      component: <AssessmentLayout />,
      path: '/assessment',
    },
    {
      id: 6,
      label: 'Class',
      labelKey: 'nav.class',
      img: <ClassIcon />,
      component: <ClassLayout />,
      path: '/class',
    },
    {
      id: 7,
      label: 'Master Data',
      labelKey: 'nav.masterData',
      img: <StorageIcon />,
      path: '/master-data',
    },
    {
      id: 19,
      label: 'Pending Enrollment',
      labelKey: 'nav.pendingEnrollment',
      img: <PendingActionsIcon />,
      path: '/pending-enrollment',
      roles: ['ADMIN', 'COACH'],
    },
    {
      id: 8,
      label: 'Report',
      labelKey: 'nav.report',
      img: <ReportIcon />,
      component: <ReportLayout />,
      path: '/report',
    },
    {
      id: 14,
      label: 'Survey Responses',
      labelKey: 'nav.surveyResponses',
      img: <SurveyResponsesIcon />,
      path: '/customer-survey/responses',
    },
    {
      id: 21,
      label: 'User Guide',
      labelKey: 'nav.userGuide',
      img: <UserGuideIcon />,
      path: '/user-guide',
    },
    {
      id: 9,
      label: 'Settings',
      labelKey: 'nav.settings',
      img: <SettingsIcon />,
      children: [
        {
          id: 10,
          label: 'Service Settings',
          labelKey: 'nav.serviceSettings',
          img: <ServiceSettingIcon />,
          component: <ServiceSetting />,
          path: '/service-setting',
        },
        {
          id: 11,
          label: 'Course Settings',
          labelKey: 'nav.courseSettings',
          img: <CourseSettingIcon />,
          component: <CourseSetting />,
          path: '/course-setting',
        },
        {
          id: 13,
          label: 'Form setting',
          labelKey: 'nav.formSetting',
          img: <FormSettingIcon />,
          path: '/customer-survey/templates',
        },
        {
          id: 15,
          label: 'Import Data',
          labelKey: 'nav.masterDataSettings',
          img: <StorageIcon />,
          component: <ImportDataSetting />,
          path: '/import-data',
        },
        {
          id: 16,
          label: 'Audit Log',
          labelKey: 'nav.auditLog',
          img: <HistoryIcon />,
          component: <AuditLogSetting />,
          path: '/audit-log',
        },
        {
          id: 17,
          label: 'Account Management',
          labelKey: 'nav.accountManagement',
          img: <ManageAccountsIcon />,
          component: <AccountManagement />,
          path: '/account-management',
        },
        {
          id: 18,
          label: 'Parent lookup setting',
          labelKey: 'nav.parentLookupSettings',
          img: <ParentLookupIcon />,
          component: <ParentLookupSetting />,
          path: '/parent-lookup-setting',
        },
        {
          id: 20,
          label: 'Parent lookup admin',
          labelKey: 'nav.parentLookupAdmin',
          img: <ParentLookupIcon />,
          path: '/parent-lookup-admin',
        },
      ],
    },
  ];
  return data;
}
